<template>
  <div class="scrapPage" v-if="!this.showLoad">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantIdName"
          v-if="mode != 'add'"
          readonly
          input-align="right"
          label="申请人："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.realName"
          class="ggInput"
          v-else
          input-align="right"
          readonly
          label="报废人："
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.createTime"
          class="ggInput"
          input-align="right"
          label="报废日期："
          readonly
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          :required="editType"
          v-model="propertyData.reason"
          rows="1"
          autosize
          label="报废原因："
          type="textarea"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="editType == true ? false : true"
        />
      </van-cell-group>
      <div class="claimDetailMain">
        <p class="fgx"></p>
        <p class="tit">报废明细</p>
        <van-cell-group class="claimDetailBox">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in scrapList"
              :key="index"
            >
              <van-cell-group class="baseNone baseSalary moreText">
                <van-field
                  v-model="item.materialCode"
                  label="报废物资编号："
                  :required="editType"
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary moreText">
                <van-field
                  v-model="item.materialType"
                  label="报废物资类型："
                  :required="editType"
                  readonly
                  class="ggInput"
                  input-align="right"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu moreText">
                <van-field
                  v-model="item.materialName"
                  label="报废物资名称："
                  :required="editType"
                  readonly
                  type="textarea"
                  rows="1"
                  autosize
                  class="ggInput"
                  input-align="right"
                  @click="showItemPickerFun(index)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>

              <div class="delect" v-if="scrapList.length > 1 && editType">
                <van-icon name="cross" @click="delect(key)" />
              </div>
            </div>
          </div>
          <div class="addBtn" v-if="editType">
            <van-button
              icon="plus"
              type="primary"
              class="addClaim"
              size="small"
              @click="addClaim"
              >添加报废明细</van-button
            >
          </div>
        </van-cell-group>
      </div>

      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="propertyData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出框 -->

    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <select-asset @setItems="setScrapItem"></select-asset>
    </van-popup>

    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const flowStaff = () => import("@/components/common/flowStaff");
const verifyMain = () => import("@/components/common/verifyMain");
const selectAsset = () => import("./components/selectAsset");
import { dateFormat, getDictList, isEdit } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";

export default {
  name: "materialScrapApply",
  components: {
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
    selectAsset,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      mode: "add",
      editType: false, //能否编辑
      currentDate: new Date(), //当前时间
      showItemPicker: false, //所属项目弹框
      showTypePicker: false, //类型弹出框
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      addType: false, //防止高频点击
      propertyData: {
        id: "",
        materialIds: [], //报废物资id
        reason: "", //报废事由

        verifyStatus: "hold",
      },

      scrapList: [
        //添加报废明细数组
        {
          materialId: "", //物资Id
          materialCode: "", //物资编号
          materialName: "", //物资名称
          materialType: "", //物资类型
        },
      ],

      typeIndex: 0, //增加报废的index
      clientType: getDeviceType(),
      sendType: "",
      pickerType: "", //判断弹出框显示是支出还是收入

      moneydetailList: [], //支出或收入详情列表
      refreshing: false, //无数据显示
      is_weixn: is_wei(), //是否为微信
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "物资报废申请";
    }
    let time = dateFormat(new Date());
    this.$set(this.propertyData, "createTime", time);
    this.$set(this.propertyData, "applicantIdName", this.userinfo.realName);
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面

    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify" || this.mode == "view") {
        this.initPage();
      } else {
        this.setShowLoad(false);
      }
    });
  },

  methods: {
    ...mapMutations(["setShowLoad"]),
    addClaim() {
      //添加报废明细函数
      this.scrapList.push({
        materialId: "", //物资Id
        materialCode: "", //物资编号
        materialName: "", //物资名称
        materialType: "", //物资类型
      });
    },

    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.administration.administration.scrapAsset
            .deleteRecall(this.propertyData.verifyStatus, _this.propertyData.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "操作成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    delect(index) {
      this.scrapList.splice(index, 1);
    },

    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.administration.administration.scrapAsset
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.scrapList = res.data.materialList;
            console.log(res.data, "获取内容");

            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },

    onTimeConfirm(data) {
      let time = dateFormat(data);
      this.showTimePicker = false;
      this.$set(this.propertyData, "createTime", time);
    },

    showItemPickerFun(index) {
      //打开类型选择弹窗
      if (!this.editType) {
        return false;
      }
      this.showItemPicker = true;
      this.typeIndex = index; //报销列表中的index
    },
    //保存报废物资
    setScrapItem(data) {
      let _this = this;
      if (data && data.code) {
        let itemData = {
          materialId: data.id,
          materialCode: data.code,
          materialName: data.materialName,
          materialType: data.materialType,
        };
        if (this.scrapList[0]) {
          let repeatType =
            this.scrapList.findIndex(
              (item) => item.materialId == itemData.materialId
            ) == -1;
          if (repeatType) {
            this.scrapList[this.typeIndex] = itemData;
          } else {
            this.$toast("报废物资已存在,不能重复选择");
          }
        } else {
          this.scrapList[this.typeIndex] = itemData;
        }
        // _this.scrapList[this.typeIndex] = itemData;
      }
      this.showItemPicker = false;
    },

    //保存
    checkInput() {
      let _this = this;
      if (this.validate()) {
        _this.btnLoading = true;
        let params = this.propertyData;
        params.materialIds = [];
        _this.scrapList.forEach((item) => {
          params.materialIds.push(item.materialId);
        });

        _this.$api.administration.administration.scrapAsset
          .addEdit(this.mode, params)
          .then((res) => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    validate() {
      let _this = this;
      if (this.propertyData.reason == "") {
        _this.$toast("请完善表单信息");
        return false;
      }
      if (this.scrapList.length > 0) {
        for (var i = 0; i < this.scrapList.length; i++)
          if (this.scrapList[i].materialName == "") {
            _this.$toast("报废物资名称不能为空");
            return false;
          }
      }
      return true;
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.scrapPage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  padding-bottom: 60px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  .moneyPicker {
    width: 100%;
    height: 90%;

    background-color: #f6f6f6;
    .van-popup__close-icon--top-right {
      top: 5px;
      right: 5px;
      color: red;
    }
    ul {
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding: 16px 16px 20px 16px;

      li {
        width: 100%;
        padding: 8px 8px;
        margin: 10px 0;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        .incomeInfo {
          p {
            width: 100%;
            overflow: hidden;
            font-size: 15px;
            line-height: 20px;
            margin: 5px 0;
            color: #333;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 135px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -67px;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  .delectBtn {
    width: 50%;
  }
  #searchHeight {
    text-align: left;
  }

  //添加明细样式
  .claimDetailMain {
    background-color: #fff;
    .fgx {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6;
    }
    p.tit {
      position: relative;
      padding: 0 16px 0 25px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #f6f6f6;
    }
    p.tit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 20px;
      background: #2581d6;
      top: 13px;
      left: 16px;
    }
    .baseNone::after {
      content: none;
    }
    .claimDetailBox.van-cell-group.van-hairline--top-bottom::after {
      content: none;
    }
  }
  .claimDetailBox {
    width: 100%;
    padding-bottom: 10px;
    .claimDetailLists {
      width: 95%;
      margin: 0 auto;
      min-height: 140px;
    }
    .addBtn {
      margin-top: 10px;
      width: 100%;
      .addClaim {
        display: block;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
      }
    }
  }
  .projectIncome {
    position: relative;
    .xmsrStyle {
      .van-cell__value {
        width: 50%;
      }
    }
    .ggInput.xmsrStyle.van-cell::after {
      content: none;
    }
  }
  .changeW.projectIncome {
    span.percent {
      position: absolute;
      width: 35px;
      top: 13px;
      right: 45px;
      color: #969799;
      font-size: 15px;
      text-align: right;
    }
  }
  .claimItem {
    margin-top: 10px;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    position: relative;
    .delect {
      text-align: center;
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      background: #fff;
      border: 1px solid red;
      color: red;
      cursor: pointer;
      padding-top: 1px;
    }
  }
  .baseNone {
    .van-cell__title {
      span {
        color: #323233;
      }
    }
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>
